import React, { useState } from 'react';
import { Button, LoadingIndicator } from '@components';

export const TermosTBSimulacao = ({ setViewTerms }) => {
  const [loading] = useState(false);
  return (
    <div className="card">
      <div className="card-body">
        {loading && <LoadingIndicator />}
        <h2>
          <strong>Como funciona o simulador?</strong>
        </h2>

        <div className="tbterms">
          <p className="tbdescription">
            Este simulador é uma ferramenta que possibilita a criação de
            diferentes cenários para facilitar sua compreensão da evolução do
            saldo de conta de aposentadoria.
          </p>
          <p className="tbdescription">
            O objetivo é apresentar resultados que te ajudem na definição da sua
            estratégia, a fim de garantir a manutenção do seu poder compra e
            prolongar a duração do saldo de conta. Lembre-se de que os
            resultados disponibilizados aqui são somente uma projeção. Portanto,
            podem ocorrer diferenças entre o resultado da simulação e o valor
            real.
          </p>
          <p className="tbdescription">
            Vale destacar ainda que o preenchimento deste simulador é hipotético
            e, por isso, não reflete diretamente na sua conta de aposentadoria.
            A solicitação de troca do percentual de recebimento mensal ou
            quaisquer outras alterações deverão seguir o fluxo habitual. Ou
            seja, através das funcionalidades disponíveis na página inicial da
            sua Área do Participante.
          </p>
          <p className="tbdescription">
            Em caso de dúvidas, entre em contato com a nossa Central de
            Atendimento pelo 0800 090 9090.
          </p>
        </div>

        <div className="tbrow" />
        <br />
        <div className="tbbutton">
          <Button className="max-180" onClick={() => setViewTerms(false)}>
            Iniciar
          </Button>
        </div>
      </div>
    </div>
  );
};
